/* eslint-disable camelcase */
export default class ShipTo {
  customer_name = null;
  partner_id = null;
  address_1 = null;
  address_2 = null;
  country_id = null;
  city_id = null;
  phone = null;
  name = null;
  division = null;
  contact = null;
  fax = null;
  email = null;
  province_id = null;
  is_tax_exemption = false;
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/ShipTo.js